<template>
<div class="loader"></div>
</template>

<script>
export default {
  name: 'dx-loader',
};
</script>

<style scoped lang="scss">
.loader {
  margin: var(--dx-space-size--xl) auto;
  border: var(--dx-space-size--xs) solid var(--dx-color--blue-light);
  border-radius: 50%;
  border-top: var(--dx-space-size--xs) solid var(--dx-color--blue-semi-light);
  width: var(--dx-avatar-size--sm);
  height: var(--dx-avatar-size--sm);
  -webkit-animation: spin 1s ease-in-out infinite; /* Safari */
  animation: spin 1s ease-in-out infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
